// extracted by mini-css-extract-plugin
module.exports = {"center":"Text_center__ev0Bm","right":"Text_right__SxVgO","light":"Text_light__Fpo66"};